import { useState, useCallback } from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { CustomerDTO } from './useCustomer';

interface UseConfirmSellerChangeProps {
  customer: CustomerDTO;
  onConfirm: () => void;
  onCancel?: () => void;
}

export const useConfirmSellerChange = ({
  customer,
  onConfirm,
  onCancel,
}: UseConfirmSellerChangeProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleConfirm = useCallback(() => {
    onConfirm();
    setIsOpen(false);
  }, [onConfirm]);

  const handleCancel = useCallback(() => {
    onCancel?.();
    setIsOpen(false);
  }, [onCancel]);

  const checkAndConfirmSellerChange = useCallback(
    (newSellerId: string) => {
      if (
        newSellerId !== customer.seller?.id?.toString() &&
        (customer.orderCount > 0 || customer.giftRequestCount > 0)
      ) {
        setIsOpen(true);
        return false;
      }
      return true;
    },
    [customer]
  );

  const ConfirmDialog = useCallback(() => {
    return (
      <AlertDialog open={isOpen} onOpenChange={setIsOpen}>
        <AlertDialogContent className="luxury-dialog">
          <AlertDialogHeader className="luxury-header">
            <AlertDialogTitle className="luxury-title">
              Xác nhận thay đổi nhân viên phụ trách
            </AlertDialogTitle>
          </AlertDialogHeader>
          <div className="space-y-6">
            <div className="luxury-card">
              <p className="text-center text-lg">
                Khách hàng này đang có {customer?.orderCount} đơn hàng và{' '}
                {customer?.giftRequestCount} yêu cầu tặng quà. Bạn có chắc chắn
                muốn thay đổi người phụ trách không?
              </p>
            </div>
          </div>
          <AlertDialogFooter className="mt-6 space-x-4">
            <AlertDialogCancel
              onClick={handleCancel}
              className="w-[120px] luxury-button-outline"
            >
              Hủy
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={handleConfirm}
              className="w-[120px] bg-red-500 hover:bg-red-600 text-white transition-colors"
            >
              Xác nhận
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    );
  }, [isOpen, customer, handleConfirm, handleCancel]);

  return {
    checkAndConfirmSellerChange,
    ConfirmDialog,
  };
};
